import {BillingService} from '../../libs/ui/src';

import {client} from '../apiService';

const _BillingService = new BillingService({client});
export {_BillingService as BillingService};
